<template>
  <div class="mt-5" v-observe-visibility="{
          callback: visibilityChanged,
          once: true,
          rootMargin: '-300px'
        }">
    <section class="bg-blue">
      <div class="container">
        <h2 id="secondvote">{{ $t('forecast_question') }}</h2>
        <i18n tag="p" class="answer" path="forecast_answer">
          <template v-slot:forecast_title>
            <span class="emph">{{ answer.party }}</span>
          </template>
          <template v-slot:forecast_percentage>
            <span class="emph">{{ answer.forecast | percentage(1) }}</span>
          </template>
        </i18n>

        <ForecastChart :data="plotData" @highlightParty="highlightParty" :survey="surveyData"/>
        <div class="text-center mt-2" v-if="!dashboard">
          <span class="switch-survey-label" :class="{active: showSurveyPoints}">{{ $t('forecast_show_polls') }}</span>
          <toggle-button v-model="showSurveyPoints"/>
        </div>
      </div>
    </section>
    <section v-if="!dashboard">
      <div class="container">
        
        <i18n tag="p" path="forecast_text_1">
          <template v-slot:today>
            <b>{{ $t('other_today')}}</b>
          </template>
          <template v-slot:past>
            <b>{{ $t('other_past')}}</b>
          </template>
        </i18n>

        <i18n tag="p" path="forecast_text_2">
          <template v-slot:estimates>
            <b>{{ $t('other_estimates')}}</b>
          </template>
          <template v-slot:day_of_election>
            <b>{{ $t('other_day_of_election')}}</b>
          </template>
          <template v-slot:downloads>
            <router-link :to="'/' + $i18n.locale + '/downloads'">{{ $t('other_downloads')}}</router-link>
          </template>
        </i18n>

        <i18n tag="p" path="forecast_text_3">
          <template v-slot:uncertainty_intervals>
            <b>{{ $t('other_uncertainty_intervals')}}</b>
          </template>
        </i18n>

      </div>
    </section>
    <section class="bg-blue" v-if="!dashboard">
      <div class="container">
          <ForecastTable :data="tableData" />
      </div>
    </section>
    <section v-if="!dashboard">
      <div class="container">

        <i18n tag="p" path="forecast_text_4">
          <template v-slot:fourteen_day_trend>
            <b>{{ $t('other_fourteen_day_trend')}}</b>
          </template>
        </i18n>

        <i18n tag="p" path="forecast_text_5">
          <template v-slot:fourthousand_polls>
            <router-link :to="'/' + $i18n.locale + '/faq#faq-3'">{{ $t('other_fourthousand_polls')}}</router-link>
          </template>
        </i18n>

      </div>
    </section>
    <section v-if="!dashboard">
      <LastPolls :polls="lastPolls"/>
    </section>
  </div>
</template>

<script>
import { map } from "lodash";
import ForecastChart from "./ForecastChart";
import ForecastTable from "./ForecastTable";
import LastPolls from "./LastPolls";

export default {
  name: "Forecast",
  components: {
    ForecastChart,
    ForecastTable,
    LastPolls,
  },
  data() {
    return {
      index: 0,
      showSurveyPoints: false
    };
  },
  computed: {
    plotData() {
      return this.$store.getters.forecastChartData;
    },
    surveyData() {
      if (!this.showSurveyPoints) return null;

      return this.$store.getters.survey;
    },
    lastPolls () {
      if (!this.$store.getters.lastPolls) return [];

      return this.$store.getters.lastPolls;
    },
    tableData() {
      return this.$store.getters.forecastTableData;
    },
    answer() {
      if (this.tableData.length > 0) {
        let point = this.tableData[this.index];

        return {
          party: this.$store.getters.partyInText[point.party_id],
          forecast_upper: point.forecast_upper,
          forecast_lower: point.forecast_lower,
          forecast: point.forecast,
        };
      }

      return {
        party: "NA",
        forecast_upper: "NA",
        forecast_lower: "NA",
        forecast: "NA",
      };
    },
  },
  methods: {
    highlightParty(val) {
      if (this.tableData.length == 0) return;
      let parties = map(this.tableData, "party_id");
      let index = parties.indexOf(val);

      if (index !== null && index >= 0) {
        this.index = index;
      }
    },
    visibilityChanged (isVisible) {
        if (isVisible) {
            this.$store.dispatch('getForecast');
            this.$store.dispatch('getForecastAll');
            this.$store.dispatch('getSurvey');
        }
    }
  },
};
</script>
